import { render } from "./AppInputNumber.vue?vue&type=template&id=64873610&scoped=true&ts=true"
import script from "./AppInputNumber.vue?vue&type=script&lang=ts"
export * from "./AppInputNumber.vue?vue&type=script&lang=ts"

import "./AppInputNumber.vue?vue&type=style&index=0&id=64873610&lang=postcss&scoped=true"

import exportComponent from "/builds/wVusKqw4/1/kenniss/platform/educator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64873610"]])

export default __exports__